module.exports = __webpack_public_path__ + "web/img/default.8b2a5a46.png";